/*
 * Routes-products.ts
 * Description: Includes the declaration of the
 * products routes for Vue Router
 */

// Importing components
import PageProducts from '@/pages/products/PageProducts.vue';
import PageProductsCreate from '@/pages/products/PageProductsCreate.vue';
import PageProductsUpdate from '@/pages/products/PageProductsUpdate.vue';

const routesProducts = [
    // Defining the products page route
    {
        path: '/restaurants/:id/categories/:category_id/products',
        name: 'products',
        component: PageProducts,
        props: { id: Number, category_id: Number },
        meta: { requiresAuth: true, CreateProducts: true },
    },
    // Defining the products create page route
    {
        path: '/restaurants/:id/categories/:category_id/:category_name/products',
        name: 'products-create',
        component: PageProductsCreate,
        props: { id: Number, category_id: Number, category_name: String },
        meta: { requiresAuth: true, CreateProducts: true },
    },
    // Defining the products update page route
    {
        path: '/restaurants/:id/categories/:category_id/:category_name/products/:product_id',
        name: 'products-update',
        component: PageProductsUpdate,
        props: { id: Number, category_id: Number, product_id: Number, category_name: String },
        meta: { requiresAuth: true, EditProducts: true },
    },
];
export default routesProducts;
